import type { PackageCategoryEntity } from '@/libs/api'

export const mapToPackageCategoryFieldName = (
  packageCategory: PackageCategoryEntity
) => {
  return `${packageCategory.code}/${packageCategory.name}`
}
